import { ReactComponent as IconSvg } from 'approot/shared/icons/icon_translate_active.svg';
import Icon, { IconProps } from './icon';

const IconTranslateActive = (props: IconProps) => {
  return <Icon {...props} Svg={IconSvg} />;
};

export default IconTranslateActive;
